import { NavLink } from 'react-router-dom';
import styled, { css } from 'styled-components';

import { Colors } from '@sternum/web/components/theme/constants';
import { ct } from '@sternum/web/utils/theme';

import { MenuItemLinkProps } from './MenuItemLink.types';

export const LeftBarDecoration = styled.div`
  display: none;
  position: absolute;
  left: 0;
  width: 4px;
  height: 100%;
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
  overflow: hidden;

  &:before {
    display: block;
    position: absolute;
    content: '';
    left: 0;
    height: 100%;
    width: 2px;
    background: ${Colors.BrandBlueLightest};
  }
`;

export const MenuItemLinkStyled = styled(NavLink)<MenuItemLinkProps>`
  position: relative;
  display: flex;
  align-items: center;
  padding: 0 12px;
  color: ${ct({ Dark: Colors.BrandBlueLight, Light: Colors.BrandBlueLight })};
  font-size: 12px;
  min-height: 40px;
  text-decoration: none;
  transition: background-color 0.1s ease-in-out, color 0.1s ease-in-out;

  &[disabled] {
    cursor: inherit;
  }

  &:not([disabled]).active {
    ${LeftBarDecoration} {
      display: block;
    }
  }

  ${(props) => {
    if (props.variant === 'expanded') {
      return css`
        color: ${ct({ Dark: Colors.GreyDarkerMiddle, Light: Colors.GreyDarkerMiddle })};
        font-weight: 500;
        background: transparent;
        border-radius: 4px;

        &:not([disabled]).active {
          color: ${ct({ Dark: Colors.White, Light: Colors.White })};
          background: ${ct({ Dark: Colors.DarkerText, Light: Colors.DarkerText })};
        }

        &:not([disabled]):hover {
          color: ${ct({ Dark: Colors.BrandBlueLight, Light: Colors.BrandBlueLight })};
          background: ${ct({ Dark: Colors.DarkestMiddle, Light: Colors.DarkestMiddle })};
        }
      `;
    } else if (props.variant === 'collapsed') {
      return css`
        color: ${ct({ Dark: Colors.GreyLighter, Light: Colors.GreyLighter })};
        font-weight: 400;
        background: transparent;
        border-radius: 4px;

        &:not([disabled]).active {
          color: ${ct({ Dark: Colors.White, Light: Colors.White })};
          background: ${ct({ Dark: Colors.DarkerText, Light: Colors.DarkerText })};
        }

        &:not([disabled]):hover {
          color: ${ct({ Dark: Colors.BrandBlueLight, Light: Colors.BrandBlueLight })};
          background: ${ct({ Dark: Colors.DarkestMiddle, Light: Colors.DarkestMiddle })};
        }
      `;
    }
  }}
`;
